import React, {Component} from "react";
import './Card.css';

class Card extends Component {

  render() {

    const {pristine, title, button, footer, onAlert} = this.props;

    return <section className="box">
      <header className="box-heading">
        <h2 className="box-heading__title">
          {title}
          {pristine !== undefined && !pristine &&
          <svg className="bmw-icon bmw-icon-md " aria-hidden="true" style={{marginLeft: 10}}>
            <use className="txt-success" xlinkHref="#icon-checkmark"/>
          </svg>
          }
        </h2>
        <div className="box-heading__button">
          {button}
        </div>
      </header>
      <div className={`box__body ${onAlert === true ? 'is-alert' : ''}`}>
        {this.props.children}
      </div>
      {footer}
    </section>
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/common/Card.js